import { useEffect, useState } from 'react';

export const useIsFirstRender = (): boolean => {
  const [isFirstRender, setIsFirstRender] = useState(true);
  useEffect(() => {
    setIsFirstRender(false);
  }, []);
  return isFirstRender;
};
